export default function processDelta(delta: string, deltaBuffer: string[]) {
  const updatedBuffer = [...deltaBuffer];

  if (updatedBuffer.length === 0) {
    updatedBuffer.push(""); // initiate a new sentence
  }

  const lastSentence = updatedBuffer[updatedBuffer.length - 1];

  updatedBuffer[updatedBuffer.length - 1] = lastSentence + delta;

  const updatedLastSentence = updatedBuffer[updatedBuffer.length - 1];
  const isDeltaFullSentence = /[.!?]$/.test(updatedLastSentence);
  if (isDeltaFullSentence) {
    updatedBuffer[updatedBuffer.length - 1] = replaceIdInText(updatedLastSentence);
    updatedBuffer.push(""); // initiate a new sentence
  }

  return updatedBuffer;
}

export function replaceIdInText(text: string) {
  const idRegExp = /\s\[[a-zA-Z0-9_]+\]\./;
  const hasIdInIt = idRegExp.test(text);
  if (hasIdInIt) {
    return text.replace(idRegExp, ".");
  }
  return text;
}
